module.exports = {
      id: "ic-continuous-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-2c53a1.smartcharts.svg#ic-continuous-usage",
      toString: function () {
        return this.url;
      }
    }